<template>
  <FooterLinks :heading="heading" :links="links" />
</template>

<script>
import { footerLinks } from '../../data/config';
import FooterLinks from '../FooterLinks/FooterLinks';

export default {
  name: 'CategoryLinks',
  data() {
    return {
      heading: footerLinks.popularLinks.heading,
      links: footerLinks.popularLinks.links
    }
  },
  components: {
    FooterLinks
  }
};
</script>
